import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { PulseLoader } from "react-spinners"; // Importing the loader
import { allSubRights } from "../../../data/Axios/queries";
import { roleManagemenUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { subrightColumns } from "../../../data/DynamicTable/CompanyManagementColumns";
import SubRightsForm from "./form";
const base_url = roleManagemenUrl.uri;
const SubRightTable = () => {
  const actions = {
    entity: "SubRight",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
      inputObjectName: "createCaseDynamic",
      InputObject: "newCase",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
    ViewCase: {
      key: "VIEWDETAILS",
      button_name: "View Details",
      Show_Button: false,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
  };

  return (
    <Box m="20px">
      <DynamicTable
        title="Subright Table"
        subtitle="View all Subrights, create edit or view"
        columns={subrightColumns}
        FormComponent={SubRightsForm}
        query={allSubRights}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};
export default SubRightTable;
